module.exports = __webpack_public_path__ + "img/2.8f845a3c.jpg";